<script setup>
import Layout from '../Layouts/App'
import {Head} from '@inertiajs/vue3'
import {throttle} from "lodash";
import {onMounted, onUnmounted} from "vue";
import MainMenu from "../Components/Guide/MainMenu.vue";
import ArticleComponent from "../Components/ArticleComponent.vue";
import NavComponent from "../Components/Guide/NavComponent.vue";

defineProps({
    title: String,
    theme: String || null,
    parentGuide: Object,
    guide: Object,
    categories: Array,
    category: Object,
    headings: Array
})

onMounted(() => {
    document.querySelector('body')?.classList.add('page-guide');
    calcHeadingActivity();
});

onUnmounted(() => {
    document.querySelector('body')?.classList.remove('page-guide');
})

window.addEventListener('scroll', throttle(() => {
    calcHeadingActivity();
}, 60), false);

const calcHeadingActivity = () => {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    headings.forEach((heading, index) => {
        const cursor = window.scrollY + window.innerHeight / 2.5;
        const nextHeading = headings[index + 1] || null;
        const headingHeight = nextHeading
            ? nextHeading.offsetTop - heading.offsetTop
            : heading.parentElement.offsetTop + heading.parentElement.clientHeight - heading.offsetTop;
        const navElement = document.querySelector('.nav-heading[href="#' + heading.id + '"]');

        if (!navElement) {
            return;
        }

        if (!index) {
            if (cursor < (heading.offsetTop + headingHeight)) {
                navElement.classList.add('active');
            } else {
                navElement.classList.remove('active');
            }
        }
        if (!nextHeading) {
            if (cursor >= heading.offsetTop) {
                navElement.classList.add('active');
            } else {
                navElement.classList.remove('active');
            }
        } else if ((cursor >= heading.offsetTop) && (cursor < (heading.offsetTop + headingHeight))) {
            navElement.classList.add('active');
        } else {
            navElement.classList.remove('active');
        }
    });
}

const onHeadingLinkClick = (ev) => {
    ev.preventDefault();
    const link = ev.target;
    const path = window.location.protocol + '//' + window.location.host + window.location.pathname;
    const target = document.getElementById(link.href.substring((path + '#').length));

    if (target) {
        history.replaceState(undefined, undefined, "#" + target.id);
        target.scrollIntoView({
            behavior: 'smooth'
        });
    }
}

</script>

<template>
    <Layout :theme="theme">
        <template #subHeader>
            <MainMenu :categories="categories" :category="category" :guide="guide" :parent-guide="parentGuide"/>
        </template>
        <template #default>
            <Head>
                <title>{{ title }}</title>
            </Head>

            <div class="max-w-full w-[1536px] mx-auto px-4 relative pt-8 md:pt-16">
                <div class="flex max-w-full">
                    <div class="hidden lg:block flex-none w-[19.5rem] inset-0 pr-8">
                        <NavComponent :categories="categories" :category="category" :guide="guide" :parent-guide="parentGuide" classes="text-sm sticky top-20"/>
                    </div>
                    <div class="flex-none w-full lg:w-[calc(100%-19.5rem)] flex">
                        <ArticleComponent :title="guide.title" :content="guide.content" :is-draft="!guide.is_active" classes="flex-1 w-[calc(100%-19.5rem)] max-w-none"/>
                        <div class="flex-none w-[19.5rem] hidden xl:block relative pl-8">
                            <div class="sticky top-20">
                                <div v-if="headings?.length" class="text-sm font-semibold mb-8 lg:mb-3">Содержание</div>
                                <ul class="text-sm">
                                    <li v-for="(heading) in headings">
                                        <a :href="'#' + heading.id"
                                           @click="onHeadingLinkClick"
                                           :class="{
                                               'nav-heading block leading-[2em] transition-all duration-150 border-l border-slate-900/10 dark:border-slate-100/10 hover:text-orange hover:border-orange dark:hover:border-orange [&.active]:text-orange [&.active]:border-orange': true,
                                               'pl-4': [0, 2].includes(parseInt(heading.level)),
                                               'pl-6': parseInt(heading.level) === 3,
                                               'pl-8': parseInt(heading.level) === 4,
                                               'pl-10': parseInt(heading.level) === 5,
                                               'pl-12': parseInt(heading.level) === 6,
                                           }"
                                           v-html="heading.title"
                                        ></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Layout>
</template>
